// Configuration options for the Toastr module

import toastr from 'toastr'

toastr.options.closeMethod = 'fadeOut'
toastr.options.closeDuration = 300
toastr.options.closeEasing = 'swing'
toastr.options.newestOnTop = false
toastr.options.timeOut = 4000
toastr.options.extendedTimeOut = 30000
toastr.options.progressBar = true
toastr.options.positionClass = 'toast-bottom-right'

export default toastr



// WEBPACK FOOTER //
// ./src/components/Toastr.js